import React, { FC } from 'react';
import { IconButton } from '@mui/material';

import { HelpFilledIcon, Tooltip } from 'src/shared/components';

interface Props {
  title: string;
  value: string;
  tooltipMessage: string;
}

export const AccrualBalancesMetricHeader: FC<Props> = ({ title, value, tooltipMessage }) => {
  return (
    <div>
      <div className="d-flex align-items-center justify-content-center w-100">
        <p className="small pb-0 mb-0 me-1 text-muted fw-400">{title}</p>
        <Tooltip placement="top" title={tooltipMessage}>
          <IconButton className="p-0" size="small" color="info">
            <HelpFilledIcon size={16} />
          </IconButton>
        </Tooltip>
      </div>
      <p className="mb-0 mt-1 text-center fw-400">{value}</p>
    </div>
  );
};
